import { Anchor, Stack, Text } from 'ui';

import { PagesUrl } from '../../../utils/enums';

const CheckoutDonationLegal = () => {
  return (
    <Stack gap={4}>
      <Text fz={11} ta="center">
        By clicking checkout you agree to our{' '}
        <Anchor
          href={`https://www.givebacks.com${PagesUrl.TERMS_of_SERVICE}`}
          target="_blank"
          c="cobalt"
          fz={11}
        >
          Privacy Policy
        </Anchor>{' '}
        &{' '}
        <Anchor
          href={`https://www.givebacks.com${PagesUrl.TERMS_of_SERVICE}`}
          target="_blank"
          c="cobalt"
          fz={11}
        >
          Terms of Service
        </Anchor>
      </Text>
    </Stack>
  );
};

export { CheckoutDonationLegal };
